import React, { useEffect, useState } from 'react'
import List from '../../../Component/Applications/List/applied'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import Loader from '../../../Component/Common/Loader';
import constant from '../../../constant';
import Filter from '../../../Component/Applications/Filter'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faChevronDown, faLocationDot, faPencil } from '@fortawesome/free-solid-svg-icons';
import { jobApplications, UpdateJobResponse } from '../../../action/jobs';
import { setsessionStorage } from '../../../utils';
const Index = ({ activeTab, setActiveTab }) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false)
    const [showDetail, setShowDetail] = useState(false)
    const [filter, setFilter] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState(null)
    const params = useParams()
    const fetchJobApplications = () => {
        setShowLoader(true)

        jobApplications({
            page: currentPage,
            limit: limit,
            filter: filter,
            job_id: params.job_id
        }).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                toast.error(res.error)
            }
        }).finally(() => {
            setShowLoader(false)
        })
    }
    useEffect(() => {
        fetchJobApplications()
    }, [filter, currentPage, limit])
    console.log(data)

    const generateOfferLetter = (data) => {
        window.open(constant.component.generateOffer.url + `?source=${data.SOURCE === 'STUDENT' ? 'campus' : 'jobseeker'}&aid=${data.APPLICATION_ID}&candidate=${data.SOURCE === 'STUDENT' ? data?.studentDetail?.CANDIDATE_NAME : data?.CANDIDATE_NAME}&cid=${data?.CANDIDATE_ID}&jid=${data?.JOB_ID}${data?.CAMPUS_STUDENT_ID ? '&sid=' + data?.CAMPUS_STUDENT_ID : ''}`, '_blank');
    }

    const updateResponse = (data, STATUS_ID) => {
        if (STATUS_ID == 10) {
            generateOfferLetter(data)
            return true
        }
        if (STATUS_ID == 11) {
            const model = {
                APPLICATION_ID: data.APPLICATION_ID,
                STATUS_ID: STATUS_ID,
                CANDIDATE_ID: data.CANDIDATE_ID,
                SOURCE: data.SOURCE,
                CAMPUS_STUDENT_ID: data.SOURCE === 'STUDENT' ? 0 : data.CAMPUS_STUDENT_ID,
                JOB_ID: params.job_id
            }
            UpdateJobResponse(model).then(res => {
                if (res.status) {
                    fetchJobApplications()
                }
            }).catch(err => {
                console.log(err)
            })
            return true
        }
        // if ([7, 8, 9].includes(STATUS_ID)) {

        //   let interViewStatusName = ""
        //   switch (STATUS_ID) {
        //     case 7:
        //       interViewStatusName = "INTERVIEW ROUND 1"
        //       this.setState({ interViewStatusName })
        //       break;
        //     case 8:
        //       interViewStatusName = "INTERVIEW ROUND 2"
        //       this.setState({ interViewStatusName })
        //       break;
        //     case 9:
        //       interViewStatusName = "INTERVIEW ROUND 3"
        //       this.setState({ interViewStatusName })
        //       break;
        //   }

        //   let selectedCandidateId = [...this.state.scid, data.CANDIDATE_ID]
        //   this.setState({ scid: selectedCandidateId })
        //   this.setState({ interviewTypeId: STATUS_ID })
        //   this.setState({ showModel: true })
        //   this.setState({ createLink: true })
        // }

        if (data.APPLICATION_STATUS == STATUS_ID) {
            return false
        }

        const model = {
            APPLICATION_ID: data.APPLICATION_ID,
            STATUS_ID: STATUS_ID,
            CANDIDATE_ID: data.CANDIDATE_ID,
            CAMPUS_STUDENT_ID: data.CAMPUS_STUDENT_ID,
            JOB_ID: params.job_id
        }

        UpdateJobResponse(model).then(res => {
            if (res.status) {
                fetchJobApplications()
            }

        }).catch(err => {
            console.log(err)
        })

    }
    const onSearch = (payload) => {
        setFilter(payload)
    }
    return (
        <React.Fragment>
            {showLoader && <Loader />}
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className={`${styles['text-comm']}`}><FontAwesomeIcon icon={faArrowLeft} className='pe-1'
                                onClick={() => {
                                    history.push(constant.component.dashboard.url)
                                }}
                            />{data?.count} profiles found for <strong>{data ? data.jobDetail.JOB_TITLE : ''}</strong><a className={`${styles['text-link']} ps-2`} href='javascript:void(0);'
                                onClick={() => {
                                    setShowDetail(!showDetail)
                                }}
                            >{showDetail ? 'Hide details' : 'View details'}<FontAwesomeIcon className='ps-2' icon={faChevronDown} /></a></h6>
                            <div className={`${styles['text-comm']} border-start border-end px-3 text-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faLocationDot} />{data?.jobDetail?.CITIES?.join((', '))}
                            </div>
                            {/* <div className={`${styles['text-comm']} border-end text-center px-3`}>
                                Previous:<strong>Premium</strong>
                            </div> */}
                            <div>
                                <Link to={
                                    constant.component.postOppurtunity.url
                                }
                                    onClick={() => {
                                        debugger
                                        setsessionStorage(constant.keys.jobPostingSession, { step: 2, id: params.job_id })
                                    }} className={`${styles['edit-btn']} btn`}><FontAwesomeIcon icon={faPencil} className='pe-1' />Edit</Link>
                            </div>
                        </div>
                        {showDetail && <div>

                            <h5 className={`${styles['ct-title']}`}>Showing Result for</h5>

                            {/* Keywords Section */}
                            <div className="my-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Keywords</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {
                                        // [
                                        //     "HR Recruiter",
                                        //     "Human Resource Recruiter",
                                        //     "Senior HR Recruiter",
                                        //     "HR Associate",
                                        //     "HR Professional",
                                        //     "Human Resource Intern",
                                        //     "Junior HR Executive",
                                        //     "Talent Acquisition Specialist",
                                        //     "Recruitment Consultant",
                                        // ]

                                        <span className={`${styles['ct-badge']}`}>
                                            {data?.jobDetail?.JOB_TITLE} <span className="ms-1">&times;</span>
                                        </span>
                                        // .map((keyword, index) => (
                                        //     <span key={index} className={`${styles['ct-badge']}`}>
                                        //         {keyword} <span className="ms-1">&times;</span>
                                        //     </span>
                                        // ))
                                    }
                                </div>
                            </div>

                            {/* City Section */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>City</h6>
                                {data?.jobDetail?.CITIES.map((item) => {
                                    return (<span className={`${styles['ct-badge']}`}>
                                        {item} <span className="ms-1">&times;</span>
                                    </span>)
                                })
                                }
                            </div>

                            {/* Experience Section */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Experience</h6>
                                <span className={`${styles['ct-badge']}`}>
                                    2 Years <span className="ms-1">&times;</span>
                                </span>
                            </div>

                            {/* Applied Filters */}
                            <div className="mb-3">
                                <h6 className={`${styles['pt-title']} mb-2`}>Applied Filters</h6>
                                <div className="d-flex flex-wrap gap-2">
                                    {["Legal & Regulatory", "Outsourcing BPO/BPM"].map((filter, index) => (
                                        <span key={index} className={`${styles['ct-badge']}`}>
                                            {filter} <span className="ms-1">&times;</span>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        }
                        <ul className="nav nav-justified nav-tabs mb-3 border-0">
                            <li className="nav-job nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Applied Jobs" ? "active" : ""}`}
                                    onClick={() => setActiveTab("Applied Jobs")}
                                >
                                    Applied Jobs
                                </button>
                            </li>
                            <li className="nav-job nav-item">
                                <button
                                    className={`nav-link ${activeTab === "Suggested Candidates" ? "active" : ""}`}
                                    onClick={() => setActiveTab("Suggested Candidates")}
                                >
                                    Suggested Candidates
                                </button>
                            </li>
                        </ul>
                        <div className="row">
                            <Filter
                                onSearch={(payload) => onSearch(payload)}
                            />
                            {<List
                                limit={limit}
                                setLimit={setLimit}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                data={data}
                                updateJobResponse={updateResponse}
                            />}
                        </div>
                    </div>
                </div>
            </div >
        </React.Fragment>
    )
}

export default Index